const translation = {
  title: 'การตั้งค่าความรู้',
  desc: 'ที่นี่คุณสามารถแก้ไขคุณสมบัติและการตั้งค่าการดึงข้อมูลของความรู้นี้',
  form: {
    name: 'ชื่อความรู้',
    namePlaceholder: 'กรุณากรอกชื่อความรู้',
    nameError: 'ชื่อต้องไม่ว่างเปล่า',
    desc: 'คําอธิบายความรู้',
    descInfo: 'โปรดเขียนคําอธิบายข้อความที่ชัดเจนเพื่อร่างเนื้อหาของความรู้ คําอธิบายนี้จะใช้เป็นพื้นฐานสําหรับการจับคู่เมื่อเลือกจากความรู้หลายรายการเพื่อการอนุมาน',
    descPlaceholder: 'อธิบายสิ่งที่อยู่ในความรู้นี้ (ไม่บังคับ)',
    descWrite: 'เรียนรู้วิธีเขียนคําอธิบายความรู้ที่ดี',
    permissions: 'สิทธิ์',
    permissionsOnlyMe: 'ฉันเท่านั้น',
    permissionsAllMember: 'สมาชิกในทีมทุกคน',
    permissionsInvitedMembers: 'สมาชิกในทีมบางส่วน',
    me: '(คุณ)',
    indexMethod: 'วิธีการจัดทําดัชนี',
    indexMethodHighQuality: 'คุณภาพสูง',
    indexMethodHighQualityTip: 'เรียกใช้แบบจําลองการฝังตัวสําหรับการประมวลผลเพื่อให้มีความแม่นยําสูงขึ้นเมื่อผู้ใช้สืบค้น',
    indexMethodEconomy: 'ประหยัด',
    indexMethodEconomyTip: 'ใช้เอ็นจิ้นเวกเตอร์ออฟไลน์ ดัชนีคําหลัก ฯลฯ เพื่อลดความแม่นยําโดยไม่ต้องใช้โทเค็น',
    embeddingModel: 'โมเดลการฝัง',
    embeddingModelTip: 'เปลี่ยนรุ่นที่ฝังไว้ โปรดไปที่',
    embeddingModelTipLink: 'การตั้งค่า',
    retrievalSetting: {
      title: 'การตั้งค่าการดึงข้อมูล',
      learnMore: 'ศึกษาเพิ่มเติม',
      description: 'เกี่ยวกับวิธีการดึงข้อมูล',
      longDescription: 'เกี่ยวกับวิธีการดึงข้อมูล คุณสามารถเปลี่ยนแปลงได้ตลอดเวลาในการตั้งค่าความรู้',
      method: 'วิธีการค้นคืน',
    },
    externalKnowledgeAPI: 'API ความรู้ภายนอก',
    externalKnowledgeID: 'ID ความรู้ภายนอก',
    retrievalSettings: 'การตั้งค่าการดึงข้อมูล',
    save: 'ประหยัด',
    indexMethodChangeToEconomyDisabledTip: 'ไม่สามารถดาวน์เกรดจาก HQ เป็น ECO ได้',
    helpText: 'เรียนรู้วิธีเขียนคําอธิบายชุดข้อมูลที่ดี',
    upgradeHighQualityTip: 'เมื่ออัปเกรดเป็นโหมดคุณภาพสูงแล้ว จะไม่สามารถเปลี่ยนกลับเป็นโหมดประหยัดได้',
    searchModel: 'ค้นหารุ่น',
  },
}

export default translation
